import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import * as appApiResources from '../../shared/globalcontants';
import { Router } from '@angular/router';
import { InvalidUser } from '../../shared/models/common/customerror';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/services/common.service';
import { PopupComponent } from 'src/app/shared/popup/popup.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from './loader.service';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { ApplicationId, ERRORCODE, ERRORMESSAGE } from '../../shared/globalcontants';
import moment from 'moment-timezone';
import { EatecTokenRefreshService } from './eatec-token-refresh.service';
import { applyEatecTokenPayloadToStorage } from './eatec-token-session.helper';

export interface ErrorPopModel {
  PopupHeaderContent: string;
  PopUpContent: string;
  EnableInfo ?: boolean;
  InfoMessage ?: string;
  InfoBtnState ?: string;

}

@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
  common: any;
  constructor(
    private dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router,
    private toastr: ToastrService,
    public _cs: CommonService,
    private translateService: TranslateService,
    private loaderService: LoaderService,
    private previlegeAuthorizationService: PrevilegeAuthorizationService,
    private eatecTokenRefreshService: EatecTokenRefreshService
    ) {
    this.common = this.translateService.instant('common');
  }
  public count = 0;
  public statusCount = 0;
  private requests: HttpRequest<any>[] = [];

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
        this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler):
    Observable<HttpSentEvent |
     HttpHeaderResponse |
     HttpProgressEvent |
     HttpResponse<any> |
     HttpUserEvent<any> | any> {
    // tslint:disable-next-line: no-shadowed-variable
    let error: HttpErrorResponse;
    let apiKey: any;
    if ((request.method === 'POST') && (request.body.APIKEY)) {
      apiKey = request.body.APIKEY;
      delete request.body.APIKEY;
    } else if (request.method === 'GET') {
      apiKey = request.params.get('APIKEY');
      request.params.delete('APIKEY');
    }
    const getAuthorizationBool = this.getPrivilege(apiKey); 
    if ( getAuthorizationBool ) {
      this._cs.loaderComplete = false;
      const countDownDate = moment().valueOf();
      let intervalTime = 0;
      const _this = this;
      const x = setInterval(() => {
        intervalTime = Math.floor((moment().valueOf() - countDownDate) / 1000);
        _this._cs.apiTime.next(intervalTime);
      }, 1000);
      this.requests.push(request);
      const allowLoader = this.allowLoader(request);
      if (allowLoader) {
        this.loaderService.isLoading.next(true);
        this._cs.loaderComplete = false;
      }
    
      return new Observable(observer => { 
        const clonedRequest: HttpRequest<any> =  this.addTokenToRequest(
          request, this.authenticationService.getAuthToken(),
          this.authenticationService.getInstanceFromLocal(),
          this.authenticationService.getAcceptLanguageFromLocal(),
          this.authenticationService.getDeviceIdFromLocal(),
          this.authenticationService.getDeviceNameFromLocal()
        );
        const subscription = next.handle( clonedRequest )
          .subscribe(
            event => {
              if (event instanceof HttpResponse) {
                this.removeRequest(request);
                this._cs.loaderComplete = true;
                observer.next(event);
              }
            },

            err => {
              error = err;
              const httpErr = err instanceof HttpErrorResponse ? err : null;
              if (
                httpErr?.status === 401 &&
                !request.url.includes('eatec/refreshtoken') &&
                localStorage.getItem(appApiResources.userSessionName)
              ) {
                this.eatecTokenRefreshService.performEatecRefresh().subscribe({
                  next: (res) => {
                    applyEatecTokenPayloadToStorage(res);
                    const retryReq = this.addTokenToRequest(
                      request,
                      this.authenticationService.getAuthToken(),
                      this.authenticationService.getInstanceFromLocal(),
                      this.authenticationService.getAcceptLanguageFromLocal(),
                      this.authenticationService.getDeviceIdFromLocal(),
                      this.authenticationService.getDeviceNameFromLocal()
                    );
                    next.handle(retryReq).subscribe({
                      next: (event) => {
                        if (event instanceof HttpResponse) {
                          this.removeRequest(request);
                          this._cs.loaderComplete = true;
                        }
                        observer.next(event);
                      },
                      error: (e2) => {
                        this.removeRequest(request);
                        this._cs.loaderComplete = true;
                        if (e2 instanceof HttpErrorResponse && e2.error) {
                          const response: ErrorPopModel = this.constrctErrorEngine(e2);
                          if (e2.status != 0) {
                            this.showPopUp(this.translateService.instant('common.Error'), response.InfoMessage || response.PopUpContent, '', this.translateService.instant('common.ok'));
                          }
                        }
                        observer.error(e2);
                      },
                      complete: () => {
                        this._cs.loaderComplete = true;
                        this.removeRequest(request);
                        observer.complete();
                      }
                    });
                  },
                  error: () => {
                    this.removeRequest(request);
                    this._cs.loaderComplete = true;
                    if (httpErr.error) {
                      const response: ErrorPopModel = this.constrctErrorEngine(httpErr);
                      if (httpErr.status != 0) {
                        this.showPopUp(this.translateService.instant('common.Error'), response.InfoMessage || response.PopUpContent, '', this.translateService.instant('common.ok'));
                      }
                    }
                    observer.error(err);
                  }
                });
                return;
              }
              this.removeRequest(request);
              observer.error(err);
              if (err instanceof HttpErrorResponse && err.error) {
                this._cs.loaderComplete = true;
                const response: ErrorPopModel = this.constrctErrorEngine(err);
                if (err.status != 0) {
                  this.showPopUp(this.translateService.instant('common.Error'), response.InfoMessage || response.PopUpContent, '', this.translateService.instant('common.ok'));
                }
              }
            },
            () => {
              this._cs.loaderComplete = true;
              this.removeRequest(request);
              observer.complete();
              const elapsed = Date.now() - countDownDate;
              const msg = `${request.method} "${request.urlWithParams}" ${'ok'} in ${elapsed} ms.`;
            });
        return () => {
          this._cs.loaderComplete = true;
          this.removeRequest(request);
          clearInterval(x);  // Clear the interval when unsubscribing
          subscription.unsubscribe();
        };
      });
    }
    return next.handle(request);
  }
  private addTokenToRequest(request: HttpRequest<any>, token: string, instance: string, language: string,
    deviceid: string, devicename: string): HttpRequest<any> {
      const filterValue = Number(localStorage.getItem('filterValue'));
      const headerValues = {} as any;
      if ( token ) {
        headerValues['Authorization'] = 'Bearer ' + token;
      }
      headerValues['InstanceHeader'] = instance;
      headerValues['Accept-Language'] =  language;
      headerValues['deviceid'] = deviceid;
      headerValues['devicename'] = devicename;
      if (localStorage.getItem('TimeZone')) {
        headerValues['IanaTimeZoneId'] = localStorage.getItem('TimeZone');
      }
      if (localStorage.getItem('UserTimeZone')) {
        headerValues['UserTimeZoneId'] = localStorage.getItem('UserTimeZone');
      }
      if (localStorage.getItem('tenant')) {
        headerValues['tenant'] = localStorage.getItem('tenant');
      }
      headerValues['LanguageCode'] = localStorage.getItem('SelectedLanguage') || 'en-US';
      headerValues['ApplicationId'] = ApplicationId.Mobile?.toString();
      // if (filterValue !== 0) {
      //   headerValues['DataFilterHeader'] = filterValue * 14;
      // } else {
      //   headerValues['DataFilterHeader'] = 7;
      // }
      return request.clone({ setHeaders: headerValues });
  }

  private handle500Error( errorResponse: HttpErrorResponse, next: HttpHandler) {
    const errorMsg = errorResponse.status + ': ' + errorResponse.statusText;
    this.showPopUp(this.translateService.instant('common.Error'), errorResponse.statusText,  '', this.translateService.instant('common.ok'));
  }

  private handle426Error( errorResponse: any, next: HttpHandler) {
    this.showLicencePopUp(this.translateService.instant('common.Error'), errorResponse.ReturnMessage,  '', this.translateService.instant('common.ok'));
  }

  private handle400Error( errorResponse: any, next: HttpHandler) {
    const errorMsg = errorResponse.error + ': ' + errorResponse.error_description;
    this.showPopUp(this.translateService.instant('common.Error'), errorResponse.error_description, '', this.translateService.instant('common.ok'));
  }
  private handle404Error( errorResponse: any, next: HttpHandler) {
    this.showPopUp(this.translateService.instant('common.Error'), errorResponse.message, '', this.translateService.instant('common.ok'));
  }

  private handle403Error(request: HttpRequest<any>, next: HttpHandler) {
  this.authenticationService.UnExceptionalLogout(request, next);
  }

  private getPrivilege(previlegeKey: string): boolean {
    let AuthBool: boolean;
    if ( previlegeKey && this.previlegeAuthorizationService &&  this.previlegeAuthorizationService.previlgeConfig) {
      AuthBool = this.previlegeAuthorizationService.previlegAuthenticated(previlegeKey);
    } else {
      AuthBool = true;
    }
    return AuthBool;
  }

constrctErrorEngine(errorResponse: any): ErrorPopModel {
  try {
      const errorClientModel = {} as ErrorPopModel;
        errorClientModel.EnableInfo = false;
        errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = this.translateService.instant('common.UnhandledException');
        errorClientModel.InfoBtnState = 'Less';
      if (errorResponse.hasOwnProperty('error') && errorResponse.error !== null && errorResponse.error.hasOwnProperty('Data')) {
        errorClientModel.PopupHeaderContent = ( errorResponse.error.HeaderText ) ? errorResponse.error.HeaderText : this.translateService.instant('common.ErrorOccurred'); //errorResponse.error.Message;
        errorClientModel.PopUpContent = errorResponse.error.Message;//errorResponse.error.Data.err.toString();
        if ( errorResponse.error.hasOwnProperty('Response_Code') ) {
          errorClientModel.PopUpContent = this.errorCodeHander(errorResponse.error.Message, errorResponse.error.Response_Code);
          errorClientModel.EnableInfo = true;
          errorClientModel.InfoMessage = errorResponse?.error?.Data?.err[0] ? errorResponse?.error?.Data?.err[0] : errorResponse?.error?.Message;
        }
      } else if (errorResponse.hasOwnProperty('error') && errorResponse.error !== null && errorResponse.error.hasOwnProperty('value')) {
        errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = errorResponse.error.value.toString();
        if ( errorResponse.error.hasOwnProperty('Response_Code') ) {
          errorClientModel.PopUpContent = this.errorCodeHander(errorResponse.error.value, errorResponse.error.Response_Code);
          errorClientModel.EnableInfo = true;
          errorClientModel.InfoMessage = errorResponse.error.Message;
        }
      } else if (errorResponse.hasOwnProperty('error') && errorResponse.error !== null && errorResponse.error.hasOwnProperty('errors')) {
        const errorValue = [];
        for (const property in errorResponse.error.errors) {
          if (errorResponse.error.errors.hasOwnProperty(property)) {
              console.log(errorResponse.error.errors[property]);
              errorValue.push(errorResponse.error.errors[property].toString());
          }
      }
      errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
      errorClientModel.PopUpContent = errorValue.toString();
      errorClientModel.InfoMessage = errorValue.toString();
      } else if (errorResponse.hasOwnProperty('error') && errorResponse.error === null) {
        errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = 'Error Null';
        if (errorResponse.hasOwnProperty('status') && errorResponse.status === 401) {
          errorClientModel.PopUpContent = this.errorCodeHander('Unauthorized', errorResponse.status);
        }
      } else if (errorResponse.hasOwnProperty('error') && errorResponse.error !== null && errorResponse.error.hasOwnProperty('message')) {
        const responseCode = ( errorResponse.error.hasOwnProperty('Response_Code') ) ? errorResponse.error.Response_Code :
        errorResponse.status;
        errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = this.errorCodeHander(errorResponse.error.message, responseCode);
        errorClientModel.EnableInfo = true;
        errorClientModel.InfoMessage = errorResponse.error.message;

      } else if (errorResponse.hasOwnProperty('error') && errorResponse.error !== null &&
        (errorResponse.error.Message || errorResponse.error.Title || errorResponse.error.ReturnMessage)) {
        // Integration / gateway style: { Title, Message, StatusCode, IsShowMessage }
        const apiMessage = errorResponse.error.Message || errorResponse.error.ReturnMessage || errorResponse.error.Title;
        errorClientModel.PopupHeaderContent = errorResponse.error.Title
          || this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = apiMessage;
        errorClientModel.InfoMessage = apiMessage;
      }
       else {
        const responseCode = ( errorResponse.error.hasOwnProperty('Response_Code') ) ? errorResponse.error.Response_Code :
        errorResponse.status;
        errorClientModel.PopupHeaderContent = this.translateService.instant('common.ErrorOccurred');
        errorClientModel.PopUpContent = this.errorCodeHander(errorResponse.message, responseCode);
        errorClientModel.EnableInfo = true;
        errorClientModel.InfoMessage = errorResponse.message;

      }
      errorClientModel.InfoBtnState = ( errorClientModel.PopupHeaderContent === 'Validation Failed' ) ? 'More' : 'Less';
      return errorClientModel;
  } catch (error) {
    console.error(error);
  }
}

errorCodeHander(DefaultMessage: string, ErrorCode: number): string {
  try {
    let errorMessage = DefaultMessage.toString();
    if (DefaultMessage) {
      errorMessage = DefaultMessage;
    } else{
      switch (ErrorCode) {
        case ERRORCODE.CODE_400:
          errorMessage = ERRORMESSAGE.ERROR_MESSAGE_400;
          break;
        case ERRORCODE.CODE_500:
          errorMessage = ERRORMESSAGE.ERROR_MESSAGE_500;
          break;
          case ERRORCODE.CODE_401:
          errorMessage = ERRORMESSAGE.ERROR_MESSAGE_401;
          break;
        default:
          errorMessage = DefaultMessage;
      }
    }
   return errorMessage;
  } catch (error) {
    console.error(error);
  }
}
  showPopUp(headerText: any, contentText: any, cancelText: any, confirmText: any, data = null) {
   const dialogArray = {
   headerText: headerText,
   contentText: contentText,
   cancelText: cancelText,
   confirmText: confirmText,
   cancelHelpText: 'CANCEL',
   confirmHelpText: 'ok'
  };
   this._cs.mobilePopUpProperty.data = dialogArray;
   this.dialog.open(PopupComponent,
      this._cs.mobilePopUpProperty
    );
  }
  showLicencePopUp(headerText: any, contentText: any, cancelText: any, confirmText: any, data = null) {
    const dialogArray = {
    headerText: headerText,
    contentText: contentText,
    cancelText: cancelText,
    confirmText: confirmText,
    cancelHelpText: 'cancel',
    confirmHelpText: 'ok'
   };
    this._cs.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
       this._cs.mobilePopUpProperty
     );
     dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        result = result.toLowerCase();
        switch (result) {
          case 'ok':
            this.router.navigate(['/login']);
            break;
        }
      }
    });
   }

   allowLoader(request: any) {
    try {
      if (request.url?.includes('PhysicalAutoSave')) {
        return false;
      }
      if (request.url?.includes('eatec/refreshtoken')) {
        return false;
      }
      return true;
    } catch (error) {
      console.log('Error occurred in allowLoader', error);
    }
   }
}
